// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"b7863d94","239":"d8c510dc","284":"c4ca8e09","332":"6357db64","363":"239d940f","453":"4dbb2df6","455":"a44974ad","477":"24d6531d","626":"bd32bc96","651":"ce185539","830":"cdfc9374","977":"a28c055a"}[chunkId] + ".chunk.js";
};